<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'DebtorList' }" class="nav-link">Dłużnicy</router-link></h2></page-title>

		<b-container class="col page-element">
			<alert-loading v-if="loading"></alert-loading>
			<div v-if="deletedItem" class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
			<div v-if="error" class="alert alert-danger">{{ error }}</div>

			<div v-if="!loading">	
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover table-clickable table-search">
						<thead>
							<tr>
								<td><b-form-input type="text" class="form-control input-search" v-model="filter.name"/><svg-icon name="search" /></td>
								<td><b-form-input type="text" class="form-control input-search" v-model="filter.nip"/><svg-icon name="search" /></td>
								<td>
									<dropdown-search id="status-dropdown" :elements="cessionStatus" v-model="filter.cessionAvailable" :showEmpty="true" />
								</td>
								<td><b-form-input type="text" class="form-control input-search" v-model="filter.address"/><svg-icon name="search" /></td>
								<td></td>
								<td></td>
								<td class="no-wrap"><my-button variant="info" :action="getItems"/> <my-button icon="back" variant="primary" :action="resetFilter"/></td>
							</tr>
							<tr>
								<th v-on:click="setOrder('name')" class="sorting" :class="getOrder('name')">Nazwa</th>
								<th v-on:click="setOrder('nip')" class="sorting" :class="getOrder('nip')">NIP</th>
								<th v-on:click="setOrder('cessionAvailable')" class="sorting" :class="getOrder('cessionAvailable')">Cesja</th>
								<th v-on:click="setOrder('address')" class="sorting" :class="getOrder('address')">Adres</th>
								<th v-on:click="setOrder('deptPLN')" class="sorting" :class="getOrder('deptPLN')">Zadłużenie (PLN)</th>
								<th v-on:click="setOrder('deptEUR')" class="sorting" :class="getOrder('deptEUR')">Zadłużenie (EUR)</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in items">
								<td><router-link v-if="item" :to="{name: 'DebtorShow', params: { id: item['id'] }}">{{ item['name'] }}</router-link></td>
								<td><router-link v-if="item" :to="{name: 'DebtorShow', params: { id: item['id'] }}">{{ item['nip'] }}</router-link></td>
								<td><router-link v-if="item" :to="{name: 'DebtorShow', params: { id: item['id'] }}">{{ item['cessionAvailable']|translate }}</router-link></td>
								<td><router-link v-if="item" :to="{name: 'DebtorShow', params: { id: item['id'] }}">{{ item.address.postalCode }} {{ item.address.city }}, ul. {{ item.address.street }} {{ item.address.number }}</router-link></td>
								<td><router-link v-if="item" :to="{name: 'DebtorShow', params: { id: item['id'] }}">{{ item['deptPLN'] }}</router-link></td>
								<td><router-link v-if="item" :to="{name: 'DebtorShow', params: { id: item['id'] }}">{{ item['deptEUR'] }}</router-link></td>
								<td>
									<router-link :to="{name: 'DebtorUpdate', params: { id: item['id'] }}" v-b-tooltip.hover.bottom title="Edytuj" class="btn btn-icon">
										<svg-icon name="edit"/>
									</router-link>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination :changePage="changePage" :currentPage="currentPage" :pagination="pagination"></pagination>
			</div>
		</b-container>
  	</b-container>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
  	import sort from '../../utils/order';

	export default {
		  data: function () {
			return {
              cessionStatus: [
				false,
				true
			  ]
			}
		  },
		computed: mapGetters({
			deletedItem: 'debtor/del/deleted',
			error: 'debtor/list/error',
			items: 'debtor/list/items',
			loading: 'debtor/list/loading',
			currentPage: 'debtor/list/currentPage',
        	pagination: 'debtor/list/pagination',
			order: 'debtor/list/order',
			filter: 'debtor/list/filter'
		}),
		methods: {
            resetFilter(){
              for (var key in this.filter ){
                this.filter[key] = undefined;
              }
              this.getItems();
            },
			getOrder: function(column) {
				return sort(this.order, column);
			},
			...mapActions({
				getItems: 'debtor/list/getItems',
				setOrder: 'debtor/list/order',
				changePage: 'debtor/list/changePage'
			})
		},
		created () {
			this.$store.dispatch('debtor/list/getItems')
		}
	}
</script>


// WEBPACK FOOTER //
// List.vue?55d8e640